"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pescia": {
    "50a96465": [{
      "hkey": "c1d3c89a",
      "slug": "alberghi-castellare",
      "name": "Alberghi-Castellare",
      "primary": true,
      "skipSearch": false
    }],
    "alberghi": [{
      "hkey": "c1d3c89a",
      "slug": "alberghi-castellare",
      "name": "Alberghi-Castellare",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b7aa0a82": [{
      "hkey": "c1d3c89a",
      "slug": "alberghi-castellare",
      "name": "Alberghi-Castellare",
      "primary": true,
      "skipSearch": false
    }],
    "castellare": [{
      "hkey": "c1d3c89a",
      "slug": "alberghi-castellare",
      "name": "Alberghi-Castellare",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pescia"
    }],
    "134abae0": [{
      "hkey": "38aff156",
      "slug": "collodi-ponte-all-abate",
      "name": "Collodi-Ponte all'Abate",
      "primary": true,
      "skipSearch": false
    }],
    "collodi": [{
      "hkey": "38aff156",
      "slug": "collodi-ponte-all-abate",
      "name": "Collodi-Ponte all'Abate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c3316e1f": [{
      "hkey": "38aff156",
      "slug": "collodi-ponte-all-abate",
      "name": "Collodi-Ponte all'Abate",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-all-abate": [{
      "hkey": "38aff156",
      "slug": "collodi-ponte-all-abate",
      "name": "Collodi-Ponte all'Abate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pescia"
    }]
  }
};
exports["default"] = _default;